import { render } from "./DepositInfoBox.vue?vue&type=template&id=d8163674"
import script from "./DepositInfoBox.vue?vue&type=script&lang=js"
export * from "./DepositInfoBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__